(() => {
  function mount() {
    const header = document.querySelector('.site-header');
    const menu = header?.querySelector('.shop-menu');
    if (!header || !menu || header.dataset.troMounted) return;
    header.dataset.troMounted = 'true';
    const summary = menu.querySelector('summary');
    const measure = () => document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`);
    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(header);
    const close = event => {
      if (event.type === 'keydown' && event.key !== 'Escape') return;
      if (event.type === 'click' && menu.contains(event.target)) return;
      if (menu.open) {
        const inside = menu.contains(document.activeElement);
        menu.open = false;
        if (inside && event.type === 'keydown') summary.focus();
      }
    };
    document.addEventListener('keydown', close);
    document.addEventListener('click', close);
    header.addEventListener('shopify:section:unload', () => {
      observer.disconnect();
      document.removeEventListener('keydown', close);
      document.removeEventListener('click', close);
    }, {once:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, {once:true});
  else mount();
  document.addEventListener('shopify:section:load', mount);
})();
